<template>
  <q-card class="q-pa-sm">
    <div
      class="text-body1 text-bold q-px-sm"
      :class="$q.dark.mode ? 'text-grey-2' : 'text-primary'"
    >
      Candlestick
    </div>
    <div class="row">
      <div class="col-12 col-sm-5 q-px-xs">
        <div v-if="timePeriod === 'daily' || timePeriod === 'hourly'">
          <q-input
            dense
            filled
            v-model="selectedDate"
            capslock
            mask="date"
            :rules="['date']"
            class="text-bold"
          >
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="selectedDate"
                @input="$refs.qDateProxy.hide()"
                @update:model-value="loadData(selectedDate)"
              />
            </q-popup-proxy>
            <q-icon
              name="event"
              class="text-grey text-h6 date-icon cursor-pointer q-pt-md"
            />
          </q-input>
          <div
            class="q-pa-xs text-body2"
            :class="$q.dark.mode ? 'text-grey-2' : 'text-primary'"
          >
            <span class=""> As of : </span>
            <span class="text-weight-medium">
              {{ selectedDate }}
            </span>
          </div>
        </div>
        <div v-else>
          <q-input
            dense
            filled
            v-model="selectedDate"
            capslock
            mask="date"
            :rules="['date']"
            class="text-bold"
          >
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="selectedDate"
                @input="$refs.qDateProxy.hide()"
                @update:model-value="loadData(selectedDate)"
              />
            </q-popup-proxy>
            <q-icon
              name="event"
              class="text-grey text-h6 date-icon cursor-pointer q-pt-md"
            />
          </q-input>
          <div
            class="q-pa-xs text-body2"
            :class="$q.dark.mode ? 'text-grey-2' : 'text-primary'"
          >
            <span class=""> As of : </span>
            <span class="text-weight-medium">
              {{ selectedDate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="timePeriod === 'hourly'">
      <div v-if="isMarketOn" class="q-pb-xs">
        <q-linear-progress
          stripe
          size="7px"
          :value="currentTime"
          :max="1"
          rounded
          class="q-mt-sm"
        />
      </div>

      <q-tabs
        v-model="selectedTab"
        dense
        align="justify"
        narrow-indicator
        outside-arrows
        mobile-arrows
        :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
        active-color="white"
        :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
        :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
      >
        <q-tab name="eleven" label="11 Am" no-caps />
        <q-tab name="twelve" label="12 Pm" no-caps />
        <q-tab name="one" label="1 Pm" no-caps />
        <q-tab name="two" label="2 Pm" no-caps />
      </q-tabs>
      <q-tab-panels v-model="selectedTab" animated>
        <q-tab-panel class="q-pa-none" name="eleven">
          <div class="row">
            <div
              v-for="(patterns, bullish_or_bearish, index) in resultEleven"
              :key="bullish_or_bearish"
              :class="index < 2 ? 'col-12 col-sm-5' : 'col-12 col-sm-2'"
              class="q-pa-xs"
            >
              <q-card flat bordered>
                <div
                  class="text-subtitle1 text-bold q-pa-xs"
                  :class="$q.dark.mode ? '' : 'text-primary'"
                >
                  {{ bullish_or_bearish }}
                </div>
                <q-list bordered>
                  <div class="row">
                    <div
                      :class="index < 2 ? 'col-6' : 'col-12'"
                      v-for="(pattern_info, pattern_name) in patterns"
                      :key="pattern_name"
                    >
                      <q-card
                        flat
                        bordered
                        @click="
                          onClickCandleStickSignal(pattern_info, pattern_name)
                        "
                        class="q-pa-sm q-ma-xs cursor-pointer"
                        :class="
                          $q.dark.mode
                            ? isSelected(pattern_name)
                              ? 'bg-grey-8 text-white'
                              : 'text-grey-4'
                            : isSelected(pattern_name)
                            ? 'bg-primary text-white'
                            : 'text-secondary'
                        "
                      >
                        <div class="text-bold">
                          <span> {{ pattern_name }}: </span>
                          <span
                            class="q-pl-xs"
                            :class="
                              isSelected(pattern_name)
                                ? 'text-white'
                                : 'text-red'
                            "
                          >
                            {{ pattern_info.symbols.length }}</span
                          >
                        </div>
                      </q-card>
                    </div>
                  </div>
                </q-list>
              </q-card>
            </div>
          </div>
        </q-tab-panel>
        <q-tab-panel class="q-pa-none" name="twelve">
          <div class="row">
            <div
              v-for="(patterns, bullish_or_bearish, index) in resultTwelve"
              :key="bullish_or_bearish"
              :class="index < 2 ? 'col-12 col-sm-5' : 'col-12 col-sm-2'"
              class="q-pa-xs"
            >
              <q-card flat bordered>
                <div
                  class="text-subtitle1 text-bold q-pa-xs"
                  :class="$q.dark.mode ? '' : 'text-primary'"
                >
                  {{ bullish_or_bearish }}
                </div>
                <q-list bordered>
                  <div class="row">
                    <div
                      :class="index < 2 ? 'col-6' : 'col-12'"
                      v-for="(pattern_info, pattern_name) in patterns"
                      :key="pattern_name"
                    >
                      <q-card
                        flat
                        bordered
                        @click="
                          onClickCandleStickSignal(pattern_info, pattern_name)
                        "
                        class="q-pa-sm q-ma-xs cursor-pointer"
                        :class="
                          $q.dark.mode
                            ? isSelected(pattern_name)
                              ? 'bg-grey-8 text-white'
                              : 'text-grey-4'
                            : isSelected(pattern_name)
                            ? 'bg-primary text-white'
                            : 'text-secondary'
                        "
                      >
                        <div class="text-bold">
                          <span> {{ pattern_name }}: </span>
                          <span
                            class="q-pl-xs"
                            :class="
                              isSelected(pattern_name)
                                ? 'text-white'
                                : 'text-red'
                            "
                          >
                            {{ pattern_info.symbols.length }}</span
                          >
                        </div>
                      </q-card>
                    </div>
                  </div>
                </q-list>
              </q-card>
            </div>
          </div>
        </q-tab-panel>
        <q-tab-panel class="q-pa-none" name="one">
          <div class="row">
            <div
              v-for="(patterns, bullish_or_bearish, index) in resultOne"
              :key="bullish_or_bearish"
              :class="index < 2 ? 'col-12 col-sm-5' : 'col-12 col-sm-2'"
              class="q-pa-xs"
            >
              <q-card flat bordered>
                <div
                  class="text-subtitle1 text-bold q-pa-xs"
                  :class="$q.dark.mode ? '' : 'text-primary'"
                >
                  {{ bullish_or_bearish }}
                </div>
                <q-list bordered>
                  <div class="row">
                    <div
                      :class="index < 2 ? 'col-6' : 'col-12'"
                      v-for="(pattern_info, pattern_name) in patterns"
                      :key="pattern_name"
                    >
                      <q-card
                        flat
                        bordered
                        @click="
                          onClickCandleStickSignal(pattern_info, pattern_name)
                        "
                        class="q-pa-sm q-ma-xs cursor-pointer"
                        :class="
                          $q.dark.mode
                            ? isSelected(pattern_name)
                              ? 'bg-grey-8 text-white'
                              : 'text-grey-4'
                            : isSelected(pattern_name)
                            ? 'bg-primary text-white'
                            : 'text-secondary'
                        "
                      >
                        <div class="text-bold">
                          <span> {{ pattern_name }}: </span>
                          <span
                            class="q-pl-xs"
                            :class="
                              isSelected(pattern_name)
                                ? 'text-white'
                                : 'text-red'
                            "
                          >
                            {{ pattern_info.symbols.length }}</span
                          >
                        </div>
                      </q-card>
                    </div>
                  </div>
                </q-list>
              </q-card>
            </div>
          </div>
        </q-tab-panel>
        <q-tab-panel class="q-pa-none" name="two">
          <div class="row">
            <div
              v-for="(patterns, bullish_or_bearish, index) in resultTwo"
              :key="bullish_or_bearish"
              :class="index < 2 ? 'col-12 col-sm-5' : 'col-12 col-sm-2'"
              class="q-pa-xs"
            >
              <q-card flat bordered>
                <div
                  class="text-subtitle1 text-bold q-pa-xs"
                  :class="$q.dark.mode ? '' : 'text-primary'"
                >
                  {{ bullish_or_bearish }}
                </div>
                <q-list bordered>
                  <div class="row">
                    <div
                      :class="index < 2 ? 'col-6' : 'col-12'"
                      v-for="(pattern_info, pattern_name) in patterns"
                      :key="pattern_name"
                    >
                      <q-card
                        flat
                        bordered
                        @click="
                          onClickCandleStickSignal(pattern_info, pattern_name)
                        "
                        class="q-pa-sm q-ma-xs cursor-pointer"
                        :class="
                          $q.dark.mode
                            ? isSelected(pattern_name)
                              ? 'bg-grey-8 text-white'
                              : 'text-grey-4'
                            : isSelected(pattern_name)
                            ? 'bg-primary text-white'
                            : 'text-secondary'
                        "
                      >
                        <div class="text-bold">
                          <span> {{ pattern_name }}: </span>
                          <span
                            class="q-pl-xs"
                            :class="
                              isSelected(pattern_name)
                                ? 'text-white'
                                : 'text-red'
                            "
                          >
                            {{ pattern_info.symbols.length }}</span
                          >
                        </div>
                      </q-card>
                    </div>
                  </div>
                </q-list>
              </q-card>
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>
    <div v-else>
      <div class="row">
        <div
          v-for="(patterns, bullish_or_bearish, index) in result"
          :key="bullish_or_bearish"
          :class="index < 2 ? 'col-12 col-sm-5' : 'col-12 col-sm-2'"
          class="q-pa-xs"
        >
          <q-card flat bordered>
            <div
              class="text-subtitle1 text-bold q-pa-xs"
              :class="$q.dark.mode ? '' : 'text-primary'"
            >
              {{ bullish_or_bearish }}
            </div>
            <q-list bordered>
              <div class="row">
                <div
                  :class="index < 2 ? 'col-6' : 'col-12'"
                  v-for="(pattern_info, pattern_name) in patterns"
                  :key="pattern_name"
                >
                  <q-card
                    flat
                    bordered
                    @click="
                      onClickCandleStickSignal(pattern_info, pattern_name)
                    "
                    class="q-pa-sm q-ma-xs cursor-pointer"
                    :class="
                      $q.dark.mode
                        ? isSelected(pattern_name)
                          ? 'bg-grey-8 text-white'
                          : 'text-grey-4'
                        : isSelected(pattern_name)
                        ? 'bg-primary text-white'
                        : 'text-secondary'
                    "
                  >
                    <div class="text-bold">
                      <span> {{ pattern_name }}: </span>
                      <span
                        class="q-pl-xs"
                        :class="
                          isSelected(pattern_name) ? 'text-white' : 'text-red'
                        "
                      >
                        {{ pattern_info.count }}</span
                      >
                    </div>
                  </q-card>
                </div>
              </div>
            </q-list>
          </q-card>
        </div>
      </div>
    </div>

    <div class="row q-py-xs">
      <div class="col-12 q-pa-xs">
        <q-card>
          <div class="text-subtitle1 text-bold text-primary q-pa-s">
            <ListCard
              :name="
                listCardData.name != undefined
                  ? 'Candlestick Signal - ' + listCardData?.name
                  : ' Candlestick Signal '
              "
              :type="'_mystock'"
              :data="listCardData?.symbols"
              :loading="loading"
              :activeSymbol="symbol"
              @clickSymbol="
                (eSymbol) => {
                  symbol = eSymbol;
                }
              "
            />
          </div>
          <StockWiseSignalStatus
            v-if="symbol"
            :symbol="symbol"
            class="q-mt-md"
          />
        </q-card>
      </div>
    </div>
    <StockWiseTabbedStatistics class="q-mt-sm" :symbol="symbol" />
  </q-card>
</template>

<script setup>
import { ref, onMounted, watch, onUnmounted } from "vue";
import { LocalStorage, useQuasar } from "quasar";

import { useStore } from "vuex";
import useData from "src/use/data";
import useUtils from "src/use/utils";

import ListCard from "src/components/ListCard.vue";

import StockWiseSignalStatus from "src/components/StockWiseSignalStatusCustom.vue";
import StockWiseTabbedStatistics from "src/components/StockWiseTabbedStatistics.vue";

const props = defineProps({
  timePeriod: {
    type: String,
  },
});

const store = useStore();
const {
  candleStickScanProHourly,
  candleStickScanProDaily,
  candleStickScanProWeekly,
} = useData();

const { dateToWeekRange } = useUtils();

const $q = useQuasar();

const selectedDate = ref("");
const candleStickData = ref([]);
const candleStickDataweekly = ref([]);
const candleStickDataIntrday = ref([]);
const listCardData = ref([]);
const loading = ref(true);
const symbol = ref(null);
const numberOfWeeks = ref(1);
const result = ref({});
const resultEleven = ref({});
const resultTwelve = ref({});
const resultOne = ref({});
const resultTwo = ref({});

const selectedTab = ref("two");
const currentTime = ref(0);
const currenthour = ref(new Date().getHours());

const isMarketOn = ref(LocalStorage.getItem("isMarketOn"));
let intervalId = null;
const selectedPattern = ref(null);

if (isMarketOn.value) {
  intervalId = setInterval(() => {
    if (currenthour.value >= 11 && currenthour.value < 16) {
      currentTime.value = (currenthour.value - 11) / 4;
    } else {
      currentTime.value = 0;
    }
  }, 1000);

  if (currenthour.value >= 12 && currenthour.value < 13) {
    selectedTab.value = "eleven";
  } else if (currenthour.value >= 13 && currenthour.value < 14) {
    selectedTab.value = "twelve";
  } else if (currenthour.value >= 14 && currenthour.value < 15) {
    selectedTab.value = "one";
  } else if (currenthour.value >= 15 && currenthour.value < 16) {
    selectedTab.value = "two";
  }
}

function loadData(date) {
  $q.loading.show({});
  if (props.timePeriod === "daily") {
    candleStickScanProDaily(date.replaceAll("/", "-"))
      .then((res) => {
        candleStickData.value = res.data;
        getData(candleStickData.value);
        $q.loading.hide();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        $q.loading.hide();
      });
  } else if (props.timePeriod === "weekly") {
    numberOfWeeks.value = dateToWeekRange(date);

    candleStickScanProWeekly(numberOfWeeks.value)
      .then((res) => {
        candleStickDataweekly.value = res.data;
        getData(candleStickDataweekly.value);
        $q.loading.hide();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        $q.loading.hide();
      });
  }
  candleStickScanProHourly(date.replaceAll("/", "-"))
    .then((res) => {
      candleStickDataIntrday.value = res.data;
      getDataIntraDay(candleStickDataIntrday.value);
      $q.loading.hide();
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      $q.loading.hide();
    });

  function getData(data) {
    for (let outerKey in data) {
      result.value[outerKey] = {};
      for (let innerKey in data[outerKey]) {
        result.value[outerKey][innerKey] = {
          name: innerKey,
          count: data[outerKey][innerKey].count,
          symbols: data[outerKey][innerKey].symbols.map((subArray) =>
            subArray.shift()
          ),
        };
      }
    }
  }

  function getDataIntraDay(data) {
    for (let outerKey in data) {
      resultEleven.value[outerKey] = {};
      for (let innerKey in data[outerKey]) {
        resultEleven.value[outerKey][innerKey] = {
          name: innerKey,
          count: data[outerKey][innerKey].count,
          symbols: data[outerKey][innerKey].symbols
            .filter((a) => a[a.length - 1]?.includes("T11"))
            .map((subArray) => subArray.shift()),
        };
      }
    }

    for (let outerKey in data) {
      resultTwelve.value[outerKey] = {};
      for (let innerKey in data[outerKey]) {
        resultTwelve.value[outerKey][innerKey] = {
          name: innerKey,
          count: data[outerKey][innerKey].count,
          symbols: data[outerKey][innerKey].symbols
            .filter((a) => a[a.length - 1]?.includes("T12"))
            .map((subArray) => subArray.shift()),
        };
      }
    }

    for (let outerKey in data) {
      resultOne.value[outerKey] = {};
      for (let innerKey in data[outerKey]) {
        resultOne.value[outerKey][innerKey] = {
          name: innerKey,
          count: data[outerKey][innerKey].count,
          symbols: data[outerKey][innerKey].symbols
            .filter((a) => a[a.length - 1]?.includes("T13"))
            .map((subArray) => subArray.shift()),
        };
      }
    }

    for (let outerKey in data) {
      resultTwo.value[outerKey] = {};
      for (let innerKey in data[outerKey]) {
        resultTwo.value[outerKey][innerKey] = {
          name: innerKey,
          count: data[outerKey][innerKey].count,
          symbols: data[outerKey][innerKey].symbols
            .filter((a) => a[a.length - 1]?.includes("T14"))
            .map((subArray) => subArray.shift()),
        };
      }
    }
  }
}

function onClickCandleStickSignal(data, pattern_name) {
  loading.value = false;
  listCardData.value = data;
  symbol.value = data?.symbols[0];
  selectedPattern.value = pattern_name;
}

const setInitialDate = (timePeriod) => {
  const dateKey =
    timePeriod === "daily"
      ? "asOf"
      : `asOf${timePeriod[0].toUpperCase()}${timePeriod.slice(1)}`;
  selectedDate.value = store.state.market[dateKey]?.split("T")[0] || "";
};

const loadDataBasedOnTimePeriod = (timePeriod) => {
  setInitialDate(timePeriod);
  if (selectedDate.value !== "") {
    loadData(selectedDate.value);
  }
};

onMounted(() => {
  loadDataBasedOnTimePeriod(props.timePeriod);
});

onUnmounted(() => {
  clearInterval(intervalId);
});

watch(
  () => props.timePeriod,
  (newVal, oldVal) => {
    loadDataBasedOnTimePeriod(newVal);
  }
);

const isSelected = (pattern_name) => {
  return selectedPattern.value === pattern_name;
};
</script>
